import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import TrustSection from './components/TrustSection';
import CategoryGrid from './components/CategoryGrid';
import ArticlesSection from './components/ArticlesSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://vigorbuy.garden';

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'VigorBuy Garden',
    url: siteUrl,
    description: 'The largest independent Vigorbuy Spreadsheet resource center. Discover the latest curated finds, buying guides, QC tutorials, and verified shopping resources updated weekly.',
    inLanguage: 'en',
    publisher: {
      '@type': 'Organization',
      name: 'VigorBuy Garden',
      url: siteUrl,
    },
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: siteUrl + '/search?q={search_term_string}',
      },
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <main className="min-h-screen bg-background-50">
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <Navbar />
      <article>
        <Hero />
        <TrustSection />
        <CategoryGrid />
        <ArticlesSection />
        <TestimonialsSection />
        <CTASection />
      </article>
      <Footer />
    </main>
  );
}